// extracted by mini-css-extract-plugin
export default {"title":"OrganizationForm_title__fM-Y4","header":"OrganizationForm_header__R+I7O"};